import { marketplaceApiVersionPrefix, marketplaceClient } from '../client'

export function resetPasswordRequest(email: string, locale: string) {
  return marketplaceClient.post(`${marketplaceApiVersionPrefix}/shop/reset-password-requests`, {
    email,
    locale: `${marketplaceApiVersionPrefix}/shop/locales/${locale}`,
  })
}
